/**
 * Catálogo de tipos de objeto del CMDB, con su etiqueta.
 *
 * POR QUÉ ESTÁ AQUÍ
 * ---------------------------------------------------------------------------
 * Nomenclatura y Roles tenían cada uno su copia de la lista, y las dos eran
 * cortas: solo los diez tipos de siempre (servidor, rack, chasis…). No había
 * forma de crear una regla de nombres ni un rol para una **subred**, una VLAN,
 * una VM, un servicio o un sitio web, aunque el objeto exista en el CMDB y su
 * formulario pida nombre.
 *
 * El backend valida con `ROLE_OBJECT_TYPES` (`blueprints/roles.py`) y
 * `blueprints/naming.py::_type_code` tiene el código de tres letras de cada uno:
 * si se añade un tipo aquí, hay que añadirlo allí también.
 *
 * El orden es el del menú (infraestructura → red → virtualización → servicios →
 * aplicaciones → IPAM): así la lista se lee sola.
 */
export const OBJECT_TYPES = [
  // Infraestructura
  { value: 'location', label: 'Ubicación' },
  { value: 'rack', label: 'Rack' },
  { value: 'server', label: 'Servidor' },
  { value: 'chassis', label: 'Chasis' },
  { value: 'storage', label: 'Cabina de almacenamiento' },
  { value: 'pdu', label: 'PDU' },
  { value: 'ups', label: 'SAI / UPS' },
  { value: 'panel', label: 'Patch panel' },
  { value: 'workstation', label: 'Estación de trabajo' },
  { value: 'ip_phone', label: 'Teléfono IP' },
  { value: 'printer', label: 'Impresora' },
  { value: 'peripheral', label: 'Periférico' },
  { value: 'wall_outlet', label: 'Toma de pared' },
  // Red
  { value: 'switch', label: 'Switch' },
  { value: 'router', label: 'Router' },
  { value: 'firewall', label: 'Firewall' },
  { value: 'wifi_controller', label: 'Controlador WiFi' },
  { value: 'wifi_ap', label: 'Punto de acceso WiFi' },
  { value: 'radius_server', label: 'Servidor RADIUS' },
  // Virtualización
  { value: 'virt_hypervisor', label: 'Hipervisor' },
  { value: 'virt_cluster', label: 'Clúster' },
  { value: 'virt_vswitch', label: 'Switch virtual' },
  { value: 'virt_vm', label: 'Máquina virtual' },
  // Servicios y aplicaciones
  { value: 'service', label: 'Servicio' },
  { value: 'service_farm', label: 'Granja de servicios' },
  { value: 'web_site', label: 'Sitio web' },
  { value: 'database', label: 'Instancia de base de datos' },
  { value: 'license', label: 'Licencia' },
  { value: 'backup_policy', label: 'Política de backup' },
  // IPAM
  { value: 'ipam_subnet', label: 'Subred' },
  { value: 'ipam_vlan', label: 'VLAN' },
];

/** Etiqueta de un tipo de objeto; si no está en el catálogo, el valor crudo. */
export const etiquetaObjeto = (tipo) =>
  OBJECT_TYPES.find((o) => o.value === tipo)?.label || tipo;

/** Solo los valores (para listas de validación o arrays de opciones). */
export const OBJETOS = OBJECT_TYPES.map((o) => o.value);

export default OBJECT_TYPES;
